import React, { useContext } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { Typography, BDSProvider } from '@barracuda-internal/bds-core-v2';
import { SideDetailContext } from './SideDetailPanel';
import useDetectionStyles from './styles/detection';
const PreviewToolTip = ({
	finding,
	previewIndex,
	previewId,
	setShowFBPopup,
	previewUrl,
}) => {
	const { setFeedbackFinding, classifierTags, setValidFindingFromRedaction } =
		useContext(SideDetailContext);
	const customClasses = useDetectionStyles();
	const tooltipTypoSx = { color: '#fff', fontSize: '12px' };
	const getFindingStyle = (finding) => {
		const style: React.CSSProperties = {
			position: 'absolute',
			left: `${finding.left}px`,
			top: `${finding.top}px`,
			width: `${finding.width}px`,
			height: `${finding.height}px`,
			cursor: 'pointer',
		};
		return style;
	};

	const openFeedbackPopUp = async () => {
		setShowFBPopup(true);
		setFeedbackFinding({ ...finding, previewUrl, previewIndex, previewId });
		const index = classifierTags.findIndex(
			(tag) => tag.text == finding.findingTag,
		);
		index === -1
			? setValidFindingFromRedaction(false)
			: setValidFindingFromRedaction(true);
	};

	return (
		<BDSProvider>
			<div onClick={openFeedbackPopUp}>
				<Tooltip
					title={
						<>
							<Typography
								className={
									customClasses[
										'img-preview-classifier-tooltip-typo'
									]
								}
								sx={tooltipTypoSx}
							>
								<b>{finding.findingTag}</b>
							</Typography>
							<Typography
								className={
									customClasses[
										'img-preview-classifier-tooltip-typo'
									]
								}
								sx={tooltipTypoSx}
							>
								Click to provide feedback and remove the
								detection.
							</Typography>
						</>
					}
					slotProps={{
						tooltip: {
							sx: {
								backgroundColor: '#646464',
								boxShadow: 1,
							},
						},
					}}
				>
					<div style={getFindingStyle(finding)}></div>
				</Tooltip>
			</div>
		</BDSProvider>
	);
};

export default PreviewToolTip;
